import React from 'react';
import { Box, Checkbox, FormControlLabel, FormHelperText, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import useLocalizedMarketingPath from '../../hooks/useLocalizedMarketingPath';
import { BRAND } from '../../theme/brandTokens';

const linkSx = {
  color: BRAND.accentText,
  fontWeight: 600,
  textDecoration: 'none',
  '&:hover': { textDecoration: 'underline' },
};

const LegalTermsCheckbox = ({ checked, onChange, error }) => {
  const { t } = useTranslation();
  const localizePath = useLocalizedMarketingPath();

  return (
    <Box sx={{ width: '100%', mt: 1 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={(event) => onChange(event.target.checked)}
            sx={{
              color: BRAND.textMuted,
              '&.Mui-checked': { color: BRAND.accent },
              py: 0,
            }}
          />
        }
        label={(
          <Typography variant="body2" component="span" sx={{ color: BRAND.text }}>
            <Trans
              i18nKey="legal.registration.acceptLabelRich"
              components={{
                termsLink: <Link component={RouterLink} to={localizePath('/terms')} target="_blank" rel="noopener noreferrer" sx={linkSx} />,
                privacyLink: <Link component={RouterLink} to={localizePath('/privacy')} target="_blank" rel="noopener noreferrer" sx={linkSx} />,
              }}
            />
          </Typography>
        )}
        sx={{ alignItems: 'center', m: 0 }}
      />
      {error && (
        <FormHelperText error sx={{ ml: 4 }}>
          {t(error)}
        </FormHelperText>
      )}
    </Box>
  );
};

export default LegalTermsCheckbox;
